import React, { useContext } from "react";
import { Box, ButtonRow, Title } from "../../styles";
import AuthViewModel from "../../viewModel";
import SpinnerLoading from "components/SpinnerLoading";
import usePermission from "./usePermission";
import Button from "components/Button";
import { LOGIN } from "constants/path";

function Permission() {
	const { isLoading, message, navigate } = usePermission();

	return (
		<Box>
			{isLoading ? <SpinnerLoading /> : (
				<>
					<Title $error>{message}</Title>
					<ButtonRow>
						<Button onClick={() => navigate(LOGIN)}>Back</Button>
					</ButtonRow>
				</>
			)}

		</Box>
	)
}

export default AuthViewModel.withProvider(Permission);
